import createActionCreator from '../utils/create-action-creator';
import actionTypes from '../constants/action-types';
import type { Subscription } from '../types/subscription';
import type { HostingPackage, HostingPackages } from '../types/hosting-package';
import type { EcommercePlans } from '../types/ecommerce-plan';

export default {
  setCurrentPackage: createActionCreator<HostingPackage>(actionTypes.SET_CURRENT_PACKAGE),
  setSubscriptions: createActionCreator<Subscription[]>(actionTypes.SET_SUBSCRIPTIONS),
  setEcommercePlans: createActionCreator<EcommercePlans>(actionTypes.SET_ECOMMERCE_PLANS),
  setHostingPackages: createActionCreator<HostingPackages>(actionTypes.SET_HOSTING_PACKAGES),
};
